export enum StorageKeys {
	access_token = 'access_token',
	refresh_token = 'refresh_token',
	name = 'name',
}

interface StorageCacheWrapper<T> {
	data: T
	timestamp: number
}

type StorageTypes = {
	[StorageKeys.access_token]: string
	[StorageKeys.refresh_token]: string
	[StorageKeys.name]: string
}

class StorageService {
	static  setItem<K extends keyof StorageTypes>(
		key: K,
		value: StorageTypes[K],
	): void {
		try {
			const jsonValue = JSON.stringify(value)
			localStorage.setItem(key, jsonValue)
		} catch (error) {
			console.error(`Error setting ${key}:`, error)
		}
	}

	static getItem<K extends keyof StorageTypes>(
		key: K,
	): StorageTypes[K] | null {
		try {
			const jsonValue = localStorage.getItem(key)
			return jsonValue ? JSON.parse(jsonValue) : null
		} catch (error) {
			console.error(`Error getting ${key}:`, error)
			return null
		}
	}

	static removeItem<K extends keyof StorageTypes>(key: K): void {
		try {
			localStorage.removeItem(key)
		} catch (error) {
			console.error(`Error removing ${key}:`, error)
		}
	}

	static clearStorage() {
		try {
			localStorage.clear()
		} catch (error) {
			console.error('Error clear storage:', error)
		}
	}
}

export default StorageService
